import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { isHeightLG, isHeightXL, isHeightXXL, isWidthSM, isWidthMD, isWidthLG, isWidthXL } from '../../reducers/app'

const mapStateToProps = ({ app: { window } }) => {
    const isLG = isWidthLG(window)

    return {
        size: {
            height: {
                isLG: isHeightLG(window),
                isXL: isHeightXL(window),
                isXXL: isHeightXXL(window),
            },
            width: {
                isSM: isWidthSM(window),
                isMD: isWidthMD(window),
                isLG,
                isXL: isWidthXL(window),
            },
        },
        isDesktop: isLG,
        isMobile: !isLG,
    }
}

export const propTypes = {
    size: PropTypes.shape({
        height: PropTypes.shape({
            isLG: PropTypes.bool.isRequired,
            isXL: PropTypes.bool.isRequired,
            isXXL: PropTypes.bool.isRequired,
        }),
        width: PropTypes.shape({
            isSM: PropTypes.bool.isRequired,
            isMD: PropTypes.bool.isRequired,
            isLG: PropTypes.bool.isRequired,
            isXL: PropTypes.bool.isRequired,
        }),
    }),
    isDesktop: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool.isRequired,
}

/**
 * Attaches size flags to a component
 * @param component React component
 * @deprecated Use `useSize` hook instead. withSize fails to work with ts props 
 */
const withSize = (component) => connect(mapStateToProps, null)(component)

withSize.propTypes = propTypes

export default withSize
